// extracted by mini-css-extract-plugin
export default {"PageContent":"chooseCompany_PageContent__I0404","CompaniesContainer":"chooseCompany_CompaniesContainer__QSfs9","CompanyItem":"chooseCompany_CompanyItem__XDIYo"};